<script>
  import Cookies from "js-cookie";
  import Authenticated from "./Authenticated.vue";
  import Guest from "./Guest.vue";

  export default {
    components: {
      Authenticated,
      Guest,
    },
    data() {
      return {};
    },
    computed: {
      isUserLoggedIn() {
        return !!Cookies.get(process.env.VUE_APP_TOKEN_KEY);
      },
    },
    methods: {},
  };
</script>
<template>
  <Authenticated v-if="isUserLoggedIn">
    <slot />
  </Authenticated>
  <Guest v-else>
    <slot />
  </Guest>
</template>

<style lang="sass" scoped>
</style>
